<template>
  <v-app-bar app>
    <v-spacer></v-spacer>

    <div class="text-center mr-4 separator-left">
      <switch-theme id="main_menu__cambiar_tema__switch" />
    </div>

    <div class="text-center mr-4 separator-left">
      <v-btn id="main_menu__notificaciones__button" class="mr-2 ml-2 mt-2" aria-label="notificaciones" text small fab>
        <v-icon>{{ icon.bell }}</v-icon>
      </v-btn>

      <v-btn id="main_menu__guia__button" @click="showInlineManual()" class="main-widget-inlinemanual mr-2 ml-2 mt-2" aria-label="guia" text small fab>
        <v-icon>{{ icon.helpTop }}</v-icon>
      </v-btn>
    </div>

    <div class="text-right mr-1 separator-left">
      <div id="main_menu__nombre_usuario__label" class="subtitle-1">{{ nombreCompleto }}</div>
      <div id="main_menu__email_usuario__label" class="subtitle-2">{{ accountData.email }}</div>
    </div>

    <v-menu open-on-hover>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          id="main_menu__perfil__button"
          class="mr-5 ml-5"
          aria-label="perfil"
          text
          v-bind="attrs"
          v-on="on"
          fab
        >
          <v-avatar color="light-blue darken-4 mr-1">
            <v-icon color="white">{{ icon.account }}</v-icon>
          </v-avatar>
          <v-icon>{{ icon.caretDown }}</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item @click="miCuenta" id="main_menu__mi_cuenta__list" key="miCuenta">
          <v-list-item-avatar>
            <v-icon small>{{ icon.account }}</v-icon>
          </v-list-item-avatar>
          <v-list-item-title>Mi Cuenta</v-list-item-title>
        </v-list-item>
        <v-list-item @click="getTermsAndConditions" id="main_menu__terminos_condiciones__list" key="terminosCondiciones">
          <v-list-item-avatar>
            <v-icon small>{{ icon.file }}</v-icon>
          </v-list-item-avatar>
          <v-list-item-title>Términos y condiciones</v-list-item-title>
        </v-list-item>
        <v-list-item @click="getNoticeOfPrivacy" id="main_menu__aviso_privacidad__list" key="avisoPrivacidad">
          <v-list-item-avatar>
            <v-icon small>{{ icon.eye }}</v-icon>
          </v-list-item-avatar>
          <v-list-item-title>Aviso de privacidad</v-list-item-title>
        </v-list-item>
        <v-divider />
        <v-list-item @click="signout" id="main_menu__cerrar_sesion__list" key="signout">
          <v-list-item-avatar>
            <v-icon color="red" small>{{ icon.power }}</v-icon>
          </v-list-item-avatar>
          <v-list-item-title>Cerrar sesión</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
import {
  mdiAccountOutline,
  mdiBellOutline,
  mdiEyeOutline,
  mdiFileDocumentOutline,
  mdiHelpCircleOutline,
  mdiMenuDown,
  mdiPower,
  mdiHelp
} from '@mdi/js'
import SwitchTheme from './SwitchTheme.vue'
import {
  userActions,
  userData,
  appThemeData,
  resourceActions,
  resourceData,
  pushNotification,
  messageErrorResponse
} from '@/store/helpers'

export default {
  name: 'MainMenu',
  components: { SwitchTheme },
  data() {
    return {
      icon: {
        bell: mdiBellOutline,
        helpTop: mdiHelp,
        account: mdiAccountOutline,
        caretDown: mdiMenuDown,
        help: mdiHelpCircleOutline,
        file: mdiFileDocumentOutline,
        eye: mdiEyeOutline,
        power: mdiPower
      },
      router: 'value'
    }
  },
  created() {
    this.getAccount()
  },
  methods: {
    ...userActions,
    ...resourceActions,
    miCuenta() {
      this.$router.replace('/account')
    },
    signout() {
      this.$router.replace('/')
      this.$vuetify.theme.dark = false
      this.logout()
    },
    getNoticeOfPrivacy() {
      this.noticeOfPrivacy()
        .then(result => {
          this.openBlankResource(result)
        })
        .catch(err => {
          this.notificationError(err)
        })
    },
    getTermsAndConditions() {
      this.termsAndConditions()
        .then(result => {
          this.openBlankResource(result)
        })
        .catch(err => {
          this.notificationError(err)
        })
    },
    openBlankResource(result) {
      if (result.data.successful.code == this.codeResourceServiceGet200) {
        window.open(result.data.data.presigned, '_blank')
      } else {
        this.notificationError(result)
      }
    },
    notificationError(msg) {
      pushNotification(
        this.$store,
        messageErrorResponse(msg) || this.msgResourceServiceError,
        'error',
        'left',
        false,
        false
      )
    },
    showInlineManual(){
      window.inline_manual_player.showPanel()
    }
  },
  computed: {
    ...userData,
    ...appThemeData,
    ...resourceData,
    nombreCompleto: {
      get() {
        return `${this.accountData.nombres} ${this.accountData.paterno} ${this.accountData.materno}`
      }
    }
  },
  mounted(){
    if (document.getElementById('idiadvize')) { return }
    let script = document.createElement('script')
    let t = document.getElementsByTagName("script")[0];
    script.setAttribute('id', 'idiadvize')
    if (typeof(iAdvize) !== "undefined"){
      script.textContent = "iAdvize.navigate('"+ window.location.pathname + "')"
    }
    t.parentNode.insertBefore(script,t)
  },
  beforeDestroy(){
    let el = document.getElementById('idiadvize')
    if (el) { el.remove() }
  }
}
</script>

<style>
.separator-left {
  border-left-style: solid;
  border-left-width: 0.15em;
  border-left-color: lightgray;
  padding-left: 1em;
  padding-right: 1em;
  height: 100%;
}
</style>
